const Analytics = {
  triggerEvent(event, parameters, fbqEvent, fbqEventId) {
    if (
      (process.env.CONTEXT === "production" ||
        process.env.GATSBY_COUNTRY === "CA") &&
      typeof window !== "undefined"
    ) {
      window.fbq("track", fbqEvent, parameters, { eventID: fbqEventId })
      window.gtag("event", event, parameters)
    }

    return true
  },
}

export default Analytics
